// extracted by mini-css-extract-plugin
export default {"border":"dx_mn","borderInvalid":"dx_mp","label":"dx_mq","labelFocused":"dx_mr"};